"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToDisplayInvoiceNumber = exports.transformInvoiceNumberToDisplayInvoiceNumber = void 0;
function transformInvoiceNumberToDisplayInvoiceNumber(numberingTemplate, invoice) {
    return transformToDisplayInvoiceNumber(invoice.prefix, invoice.invoiceNumber, numberingTemplate.digits);
}
exports.transformInvoiceNumberToDisplayInvoiceNumber = transformInvoiceNumberToDisplayInvoiceNumber;
// hey future dude, hope you changing digit number to 6 :), should be in 2023 or 2024
function transformToDisplayInvoiceNumber(prefix, invoiceNumber, digits = 5) {
    return `${prefix}${invoiceNumber.toString().padStart(digits, "0")}`;
}
exports.transformToDisplayInvoiceNumber = transformToDisplayInvoiceNumber;
//# sourceMappingURL=transformInvoiceNumberToDisplayInvoiceNumber.js.map